const LOCAL:string = "http://127.0.0.1:5004";
const PRODUCTION:string = "https://appraisal.naplast.net";
const BACKEND_URLS: string[] = [LOCAL, PRODUCTION];
export const GLOBAL_URL: string = BACKEND_URLS[1];
